(function($){

    // Menu animations
    $('#trigger').on('click', function(){

        if($(this).hasClass('open')){

            $(this).removeClass('open');
            $('html, body').removeClass('disable');
            $('#siteLogo').animate({}, 1000, function(){
                $(this).removeClass('reposition');
            });
            $('#header__contact-button').animate({}, 1000, function(){
                $(this).removeClass('reposition');
            });
            $('#mainMenu').animate({top: '-100vh'}).fadeOut(1000);

        } else {

            $('html, body').addClass('disable');
            $(this).addClass('open');
            $('#mainMenu').fadeIn(100).animate({top: '0'});
            $('#siteLogo').addClass('reposition');
            $('#siteLogo').animate({}, 750, function(){
                $(this).css('z-index', 90);
            });
            $('#header__contact-button').addClass('reposition');
            $('#header__contact-button').animate({}, 750, function(){
                $(this).css('z-index', 90);
            });

        }

    });

    $('#mainMenu a').on('click', function(){

    	if($('#trigger').hasClass('open')){

	        $('#trigger').removeClass('open');
	        $('html, body').removeClass('disable');
	        $('#siteLogo').animate({}, 1000, function(){
                $(this).removeClass('reposition');
	        });
	        $('#header__contact-button').animate({}, 1000, function(){
                $(this).removeClass('reposition');
	        });
	        $('#mainMenu').animate({top: '-100vh'}).fadeOut(1000);

	    }

    });

    // Scroll on click
    $(document).on('click', 'a[href^="#"]', function (event) {
        event.preventDefault();
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top
        }, 1000);
    });


	// Slick Sliders
	$('#slider').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 700,
		dots: true,
		arrows: true,
        prevArrow:"<button type='button' class='slick-prev'><i class='fas fa-chevron-left'></i></button>",
        nextArrow:"<button type='button' class='slick-next'><i class='fas fa-chevron-right'></i></i></button>",
		infinite: true,
		slidesToShow: 2,
		slidesToScroll: 1,
        responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1
          }
        }
        ]
	});


    // Accordions
    $(function() {
        $('.accordion-answer').hide();
        $('.accordion-question:first').addClass('active').next().slideDown('slow');
        $('.accordion-question').click(function(){
            if($(this).next().is(':hidden')) {
                $('.accordion-question').removeClass('active').next().slideUp('slow');
                $(this).toggleClass('active').next().slideDown('slow');
            } else if($(this).next().is(':visible')) {
                $(this).toggleClass('active').next().slideUp('slow');
            }
        });
    });

    // Initiate aos animations
	AOS.init();

    $(".button--text__primary:not(:has(span.c-button-text))").wrapInner('<span class="c-button-text"></span>');
    $(".wp-block-button__link:not(:has(span.c-button-text))").wrapInner('<span class="c-button-text"></span>');    

    // Remove empty paragraphs
    $('p:empty:not([role])').remove();

    $('.c-lined-heading').wrapInner('<span class="c-lined-heading-bg"></span>');

    $('.c-lined-heading').wrapInner('<span class="c-lined-heading-bg"></span>');

    $(window).on("load resize orientationchange", function() {
        $(".c-hex-clip.c-hex-border").each(function() {
            var $hexWidth = $(this).outerWidth();
            var $hexBorder = $hexWidth / 15;

            $(this).css("padding", $hexBorder+"px");
        });
    });

    $(window).on("load resize orientationchange", function() {

        var $topPad = $('.page-id-97 #siteHeader').height();
        
        $(".c-thank-you-row").css('padding-top', $topPad+'px');
        $(".c-error-row").css('padding-top', $topPad+'px');
        
    });

    $(window).on("load resize orientationchange", function() {

        var $topPad = $('#siteHeader.c-site-header-nobg').height();
        
        $(".c-thank-you-row").css('padding-top', $topPad+'px');
        $(".c-error-row").css('padding-top', $topPad+'px');
        
    });

    $(window).on("load resize orientationchange", function() {
         var $careerTopPad = $("body.single-career #siteHeader.c-site-header-nobg").height();

         $(".overlap-prevention--single").css('padding-top', $careerTopPad+'px');
    });

    $(window).on("load resize orientationchange", function() {
         var $postTopPad = $("body.single-post #siteHeader.c-site-header-nobg").height();

         $(".overlap-prevention--single").css('padding-top', $postTopPad+'px');
    });


    $(window).on("load scroll resize orientationchange", function() {
        // Hide Header on on scroll down
        var didScroll;
        var lastScrollTop = 0;
        var delta = 5;
        var navbarHeight = $("header#siteHeader").outerHeight();


        $(window).scroll(function (event) {
          didScroll = true;
        });

        setInterval(function () {
          if (didScroll) {
            hasScrolled();
            didScroll = false;
          }
        }, 250);

        function hasScrolled() {
          var st = $(this).scrollTop();
          navbarHeight = $("header#siteHeader").outerHeight();

          // Make sure they scroll more than delta
          if (Math.abs(lastScrollTop - st) <= delta) return;

          // If they scrolled down and are past the navbar, add class .nav-up.
          // This is necessary so you never see what is "behind" the navbar.
          if (st > lastScrollTop && st > 0) {
            // Scroll Down
            // $('header#siteHeader.nav-up').css('top', "-"+navbarHeight+"px");
            $("header#siteHeader").removeClass("nav-down").addClass("nav-up");
          } else {
            // Scroll Up
            if (st + $(window).height() < $(document).height()) {
             // $('header#siteHeader.nav-up').css('top', 0);
              $("header#siteHeader").removeClass("nav-up").addClass("nav-down");
            }
          }

          lastScrollTop = st;
        }

        // Navbar color change
        var $nav = $("header#siteHeader");
        $nav.toggleClass("scrolled", $(this).scrollTop() > 30);
        $(window).scroll(function () {
          var $nav = $("header#siteHeader");
          $nav.toggleClass("scrolled", $(this).scrollTop() > 30);
        });
    });

})(jQuery);